<!-- eslint-disable prettier/prettier -->
<template>
	<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :fill="color" class="ki ki-minus" viewBox="0 0 24 24">
	<path d="M24,13H0v-2h24V13z"/>
</svg>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		width?: number;
		height?: number;
		color?: string;
	}>(),
	{
		width: 24,
		height: 24,
		color: 'currentColor'
	}
);
</script>
